import React from 'react';
import Icon from '../../../components/AppIcon';

const PlatformBenefits = () => {
  const benefits = [
    {
      icon: 'Sparkles',
      title: 'AI-Powered Writing',
      description: '11 specialized AI agents guide you through every step of book creation'
    },
    {
      icon: 'TrendingUp',
      title: 'Market Research',
      description: 'Amazon BSR analysis and competitor insights for optimal positioning'
    },
    {
      icon: 'Palette',
      title: 'Professional Formatting',
      description: 'KDP-ready print and ebook formatting with custom cover design'
    },
    {
      icon: 'Users',
      title: 'Community Access',
      description: 'Exclusive community for networking and support for paid members'
    },
    {
      icon: 'Zap',
      title: 'Fast Results',
      description: 'Complete your book in weeks, not months or years'
    },
    {
      icon: 'Award',
      title: 'Build Authority',
      description: 'Establish credibility and unlock speaking opportunities'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="text-center lg:text-left">
        <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
          Welcome Back to Your Publishing Journey
        </h3>
        <p className="text-sm text-muted-foreground">
          Continue building your authority with AI-powered book creation
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">
        {benefits?.map((benefit, index) => (
          <div
            key={index}
            className="flex items-start space-x-3 p-4 bg-card border border-border rounded-lg hover:shadow-md transition-shadow duration-200"
          >
            <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={benefit?.icon} size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-foreground mb-1">
                {benefit?.title}
              </h4>
              <p className="text-xs text-muted-foreground">
                {benefit?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="p-4 bg-accent/10 border border-accent rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="Star" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-foreground mb-1">
              Join Like-Minded Authors
            </p>
            <p className="text-xs text-muted-foreground">
              Entrepreneurs and professionals who have published their authority-building books with AuthorPreneur AI
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformBenefits;